import { render, staticRenderFns } from "./ShippingAddFormInfo.vue?vue&type=template&id=a5da6d08"
import script from "./ShippingAddFormInfo.vue?vue&type=script&lang=js"
export * from "./ShippingAddFormInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports